import { render } from "./TheHeader.vue?vue&type=template&id=184bfcaa"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=184bfcaa&lang=css"

import exportComponent from "/home/runner/work/bomoindustrial-vue/bomoindustrial-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__